import React from "react";
import { Switch, BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import {
  HomeView,
  LoginView,
  RegisterView,
  ForgotPasswordView,
  PersonDetailsView,
  SearchView,
  GalleryView,
  FamilyTreeView,
} from "./views";
import { PrivateRoute, GuestRoute } from "./components";
import { AuthProvider } from "./providers";
import "./App.less";
import "./assets/css/tailwind/tailwind.generated.css";

const App: React.FC = () => (
  <ThemeProvider theme={{ mode: "light" }}>
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <GuestRoute path="/forget-password" component={ForgotPasswordView} />
          <GuestRoute path="/login" component={LoginView} />
          <GuestRoute path="/register" component={RegisterView} />
          <PrivateRoute path="/person/:id/details" component={PersonDetailsView} />
          <PrivateRoute path="/search" component={SearchView} />
          <PrivateRoute path="/gallery" component={GalleryView} />
          <PrivateRoute path="/family-tree" component={FamilyTreeView} />
          <PrivateRoute path="/" component={HomeView} />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  </ThemeProvider>
);

export default App;
